import { privateCallEntity } from '@/src/entities/private-call'

export function pathSet(path: string) {
  const store = privateCallEntity.model.usePrivateCallStore()
  store.entryPath = path
}
